import { isNil } from 'lodash';

export function formatDate(dateString) {
  if (isNil(dateString)) {
    return '-';
  }

  // Cannot use "toLocaleDateString" due to timezone errors
  return dateString.substring(0, 10).split('-').reverse().join('/');
}

export function formatNumber(val, formatOptions = { maximumFractionDigits: 8 }) {
  if (isNil(val)) {
    return '-';
  }

  const intlObj = new Intl.NumberFormat('pt-BR', { ...formatOptions });

  return intlObj.format(val);
}

export function formatPercentage(val, formatOptions = { maximumFractionDigits: 2 }) {
  if (isNil(val)) {
    return '-';
  }

  const intlObj = new Intl.NumberFormat('pt-BR', { style: 'percent', ...formatOptions });

  return intlObj.format(val);
}

export function formatCurrency(val, formatOptions = {}) {
  if (isNil(val)) {
    return '-';
  }

  // const intlObj = new Intl.NumberFormat('pt-BR', {
  //   style: 'currency',
  //   currency: 'BRL',
  //   ...formatOptions,
  // });

  // NOTE: Currently all values are BRL, so we format them as decimal numbers
  const intlObj = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...formatOptions,
  });

  return intlObj.format(val);
}
